// @ts-nocheck
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
// material
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import {
  Grid,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableBody,
} from '@material-ui/core';
// utils
import { fCurrency, fNumber } from 'utils/functions';
import moment from 'moment';
// components
import StyledTableCell from 'commons/components/StyledTableCell';

function CostMarginTable(props) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(true);

  const handleClose = () => {
    setOpen(false);
    props.onClose();
    props.resetSelectedProductId();
  };

  return (
    <Dialog
      fullWidth
      maxWidth="md"
      // open={props.showCostMarginTable}
      open={open}
      onClose={handleClose}>
      <DialogTitle>{t('productsReport.costDetail.title')}</DialogTitle>
      <DialogContent>
        <Grid container item spacing={3} className="{props.classes.container}">
          <Grid item xs={12} className={props.classes.containerTable}>
            <TableContainer component={Paper}>
              <Table className="{props.classes.table}">
                <TableHead>
                  <TableRow>
                    <StyledTableCell>{t('productsReport.costDetail.concept')}</StyledTableCell>
                    <StyledTableCell>{t('productsReport.costDetail.totalCost')}</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {props.accumulatedCost[props.selectedProductId] && (
                    <TableRow key={props.selectedProductId}>
                      <StyledTableCell>{t('productsReport.costDetail.staff')}</StyledTableCell>
                      <StyledTableCell>
                        {fCurrency.format(
                          props.accumulatedCost[props.selectedProductId].employeeCost,
                        )}
                      </StyledTableCell>
                    </TableRow>
                  )}
                  {props.accumulatedCost[props.selectedProductId] && (
                    <TableRow key={props.selectedProductId}>
                      <StyledTableCell>{t('productsReport.costDetail.supplies')}</StyledTableCell>
                      <StyledTableCell>
                        {fCurrency.format(
                          props.accumulatedCost[props.selectedProductId].supplyCosts,
                        )}
                      </StyledTableCell>
                    </TableRow>
                  )}
                  {props.accumulatedCost[props.selectedProductId] && (
                    <TableRow key={props.selectedProductId}>
                      <StyledTableCell>{t('productsReport.costDetail.waste')}</StyledTableCell>
                      <StyledTableCell>
                        {fCurrency.format(props.accumulatedCost[props.selectedProductId].wasteCost)}
                      </StyledTableCell>
                    </TableRow>
                  )}
                  {props.accumulatedCost[props.selectedProductId] && (
                    <TableRow key={props.selectedProductId}>
                      <StyledTableCell>{t('productsReport.costDetail.rawMaterialCost')}</StyledTableCell>
                      <StyledTableCell>
                        {fCurrency.format(
                          props.accumulatedCost[props.selectedProductId].receiptCost,
                        )}
                      </StyledTableCell>
                    </TableRow>
                  )}
                  {props.accumulatedCost[props.selectedProductId] && (
                    <TableRow key={props.selectedProductId}>
                      <StyledTableCell>{t('productsReport.costDetail.totalCost')}</StyledTableCell>
                      <StyledTableCell>
                        {fCurrency.format(
                          props.accumulatedCost[props.selectedProductId].accumulatedCost,
                        )}
                      </StyledTableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          {t('productsReport.costDetail.close')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default CostMarginTable;
